import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

export function PageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
      <div>
        {subtitle && <div className="label-tiny text-primary mb-2">{subtitle}</div>}
        <h1 className="text-2xl sm:text-3xl font-extrabold">{title}</h1>
      </div>
      {action}
    </div>
  );
}

export function StatCard({ label, value, hint, className }) {
  return (
    <Card className={cn("p-4 bg-card/60 border-border", className)}>
      <div className="label-tiny mb-2">{label}</div>
      <div className="text-3xl font-extrabold font-display">{value}</div>
      {hint && <div className="text-xs text-muted-foreground mt-2">{hint}</div>}
    </Card>
  );
}

export function Empty({ title, hint, action }) {
  return (
    <div className="text-center px-4 py-6 border border-dashed border-border rounded-lg" data-testid="empty-state">
      <div className="text-lg font-semibold">{title}</div>
      {hint && <div className="text-sm text-muted-foreground mt-1">{hint}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
